import './new-sdc';
import './_module';
import './_redirects';
import './changelog.route';
import './cluster.route';
import './home.route';
import './main.route';
import './modals.route';
import './school.route';
import './settings.route';
import './student.route';
import './supports.route';
import './data-entry.route';
